module.exports = __webpack_public_path__ + "static/00094.b2b375a2.jpg";